import React from "react";
import { Users, Home } from "./icons";
import "../styles/StatCards.css";

/* Inline SVGs — kept local (not from lucide-react) so we don't risk
   clashing with whatever "./icons" wraps internally. */
function CheckCircle2(props) {
  return (
    <svg viewBox="0 0 24 24" width={props.size || 15} height={props.size || 15} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
      <polyline points="22 4 12 14.01 9 11.01" />
    </svg>
  );
}

function AlertTriangle(props) {
  return (
    <svg viewBox="0 0 24 24" width={props.size || 15} height={props.size || 15} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0Z" />
      <line x1="12" y1="9" x2="12" y2="13" />
      <line x1="12" y1="17" x2="12.01" y2="17" />
    </svg>
  );
}

/**
 * StatCards
 * Four-up summary row shown above the patient table on Program Overview.
 *
 * Props:
 *  - stats ({ total, active, completed, needsAttention })
 */
export default function StatCards({ stats = {} }) {
  const {
    total = 0,
    active = 0,
    completed = 0,
    needsAttention = 0,
  } = stats;

  const cards = [
    { key: "total", label: "Total Patients", value: total, icon: Users, tone: "purple" },
    { key: "active", label: "Active In Program", value: active, icon: Home, tone: "blue" },
    { key: "completed", label: "Completed", value: completed, icon: CheckCircle2, tone: "green" },
    { key: "attention", label: "Needs Attention", value: needsAttention, icon: AlertTriangle, tone: "orange" },
  ];

  return (
    <div className="cc-stats-row">
      {cards.map(({ key, label, value, icon: Icon, tone }) => (
        <div className="cc-stat-card" key={key}>
          <span className={`cc-stat-icon cc-stat-icon--${tone}`}>
            <Icon size={19} />
          </span>
          <span className="cc-stat-label">{label}</span>
          <span className="cc-stat-value">{value}</span>
        </div>
      ))}
    </div>
  );
}